import './App.css';
import {BrowserRouter as Router , Switch, Route} from 'react-router-dom'
import DotaPage from './pages/dotapage/DotaPage';
import FreefirePage from './pages/freefirepage/FreefirePage';
import HomePage from './pages/homepage/HomePage';
import MolenPage from './pages/molenpage/MolenPage';
import ValorPage from './pages/valorantpage/ValorPage';
import Navbar from './component/navbar/Navbar';

function App() {
  return (
    <Router>
      <Navbar/>
      <Switch>
        <Route path="/" exact component={HomePage}/>
        <Route path="/dota" exact component={DotaPage}/>
        <Route path="/molen" exact component={MolenPage}/>
        <Route path="/ff" exact component={FreefirePage}/>
        <Route path="/valor" exact component={ValorPage}/>
      </Switch>
    </Router>
  );
}

export default App;
